import { render, staticRenderFns } from "./TableV2.vue?vue&type=template&id=399adc37&scoped=true&"
import script from "./TableV2.vue?vue&type=script&lang=js&"
export * from "./TableV2.vue?vue&type=script&lang=js&"
import style0 from "./TableV2.vue?vue&type=style&index=0&id=399adc37&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399adc37",
  null
  
)

export default component.exports